export const MOCK_CONFIG = {
  API_DELAY: 100,

  POLLING_ITERATIONS_BEFORE_COMPLETE: 9,
}
